import React from "react"
import { Layout, Menu } from 'antd'
import { Link } from 'react-router-dom';

import { IMenuModel } from "../models/MenuItems";
import { IMenuService } from "../services/shared/MenuService";
import SERVICE_IDENTIFIER from "../wires/Identifiers";
import container from "../wires/Bootstrapper";

const { Sider } = Layout

const MenuItem = (data) => {
    const { id, link, description, icon } = data;
    const returnValue = [];


    if (data.link != null) {

        let menuProps = {
            key: id,
            icon: undefined
        }

        if (data.icon != null)
            menuProps.icon = AntIcon(icon)

        returnValue.push(
            <Menu.Item {...menuProps}>
                <Link to={link}>{description}</Link>
            </Menu.Item>
        );
    }

    if (data.groupName != null && data.groupName !== '')
        returnValue.push(SubMenu(data));

    return returnValue;

};

const SubMenu = (data) => {
    const { groupName, menu, icon } = data;
    return (
        <Menu.SubMenu icon={AntIcon(icon)} title={groupName} >
            {menu.map(MenuItem)}
        </Menu.SubMenu>
    );
};

/// PREFERIRE SEMPRE LA VERSIONE COMPONENTE ED USARE SOLAMENTE 
/// QUANDO IL RIFERIMENTO ALL'ICONA VIENE PASSATO DAL SERVER.
/// NO: AntIcon("CompressOutlined")
/// SI: <CompressOutlined />
const AntIcon = (icon: string) => {
    let icons = require(`@ant-design/icons`)
    const Component = icons[icon]
    return <Component />
}

export class AppSidebar extends React.Component<any, IMenuModel> {

    service: IMenuService

    constructor(props) {
        super(props);
        this.service = container.get(SERVICE_IDENTIFIER.MENU_SERVICE);
        this.state = { menu: [] };
    }


    async componentDidMount() {
        let resp = await this.service.getMenu();
        this.setState(resp as IMenuModel);
    }

    getSelectedItems = () => {
        var arr = []
        if (this.state.menu != null && this.state.menu.length > 0) {
            arr.push(this.state.menu[0].id)
        }

        return arr;
    }

    render() {
        return (
            <Sider
                theme="light"
                breakpoint="sm"
                width={220}
                collapsible>
                <Menu mode="inline">
                    {this.state.menu.map(MenuItem)}
                </Menu>
            </Sider>
        )
    }
}